import { useCallback } from 'react';
import { modals } from '@/modals';
import { useModals } from '@/modals/context';
import PermissionChip from '@/app/pages/LobbyPage/PermissionChip';
import { Permission, RequestPermissions } from '@/app/types';

import { EVENTS, gtag } from '@/lib/gtag';

const DEVICE_NAME: Record<Permission, string> = {
  audio: 'Microphone',
  video: 'Camera',
}

export default function DevicePermissionChip({
  permission, hasPermission, requestPermissions
}: { permission: Permission, hasPermission?: boolean, requestPermissions: RequestPermissions }) {
  const { show } = useModals();

  const onRequestPermissions = useCallback(() => {
    requestPermissions({ [permission]: true }).catch(() => {
      // missing permissions
      const permissions = { [permission]: true };

      gtag(EVENTS.SHOW_MODAL, permissions);
      show({ modal: modals.RESET_PERMISSIONS_MODAL, permissions });
    });
  }, [permission, requestPermissions, show]);

  return (
    <PermissionChip
      granted={Boolean(hasPermission)}
      name={DEVICE_NAME[permission]}
      onEnable={onRequestPermissions}
    />
  );
}
